import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CompanyServicesModel } from "model/screensModels/CompanyServicesModel";
import { CompanyServicesService } from "services/menu/companyServicesService/CompanyServicesService";
import { msgTypes } from "constants/msgTypes";
import CardActionArea from '@mui/material/CardActionArea';
import './CompanyServices.scss'
import { UtilService } from "services/shared/UtilService";
import { MembershipModel } from "model/screensModels/membership/MembershipModel";
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import SpokeIcon from '@mui/icons-material/Spoke';

const TRUNCATE_LENGTH = 150;

function CompanyServices({ companyId }) {
  const [serviceList, setServiceList] = useState([]);
  // const [openDialog, setOpenDialog] = useState(false);
  // const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    if (companyId !== undefined && companyId !== '')
      getCompanyServiceList();
  }, [companyId]);



  // const getCompanyServiceList = async () => {
  //   const requestBody = new MembershipModel();
  //   requestBody.companyId = companyId;
  //   const res = await UtilService.getCompanyDetailsByCompanyId(requestBody);
  //   console.log("company service is ", res)
  //   if (res.statusMsg === msgTypes.SUCCESS.msg) {
  //     if (res.data !== '') {
  //       setServiceList(res?.data?.companyServicesDetail);
  //     }
  //     else {
  //       setServiceList([]);
  //     }
  //   }
  // };
  const getCompanyServiceList = async () => {
  const requestBody = new MembershipModel();
  requestBody.companyId = companyId;
  const res = await UtilService.getCompanyDetailsByCompanyId(requestBody);
  // console.log("company service is", res);

  if (res.statusMsg === msgTypes.SUCCESS.msg) {
    const services = res?.data?.[0]?.companyServicesDetail || [];
    setServiceList(services);
  } else {
    setServiceList([]);
  }
};

  // const slidesToShow = 4;
  // const hasEnoughSlides = serviceList.length >= slidesToShow;

  // const settings = {
  //   autoplay: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: hasEnoughSlides ? slidesToShow : serviceList.length,
  //   slidesToScroll: hasEnoughSlides ? 1 : 0,
  //   arrows: false,
  // };

  // const handleOpenDialog = (service) => {
  //   setSelectedService(service);
  //   setOpenDialog(true);
  // };

  // const handleCloseDialog = () => {
  //   setOpenDialog(false);
  //   setSelectedService(null);
  // };
  const NoServices = () =>{
    return (
      <div className="d-table h-100 w-100">
      <div className="card border-0 no-data-found d-table-cell p-4 align-middle text-center w-100 bg-white">
        <img src="/images/no-data-found.png" alt="" />
        <p className="text-center">Company services Not Available !</p>
      </div>
    </div>
    )
  }

  return (
    <>
      {serviceList ? (

        <Box className="card border-0 featured-member bg-white h-100">
          <Grid item className="main-grid h-100">
            {serviceList?.length === 0 ? (
             <NoServices />
            ) : (
              <>
                <div className="card border-0 h-100">
                  <div className="card-header pb-0 p-3">
                    <div className="row">
                      <div className="col-md-8 d-flex align-items-center">
                        <h6>Company Services</h6>
                      </div>
                    </div>
                  </div>
                  <div className="card-body company-service-section p-3">
                    <div className="row">
                      <div className="col-12">
                        {serviceList?.map((data, index) => (
                          <div key={index} className="services-list">
                            <div>
                              <div className="d-flex">
                                <div className="px-2 spoke-icon"><SpokeIcon /></div>
                                <div><h6 className="font-weight-bolder text-sm">{data?.serviceName}</h6></div>
                              </div>
                              {/* <p>{data.description.length > TRUNCATE_LENGTH
                                ? `${data.description.substring(0, TRUNCATE_LENGTH)}...`
                                : data.description}</p> */}
                              {/* <p className="text-sm">{data.description}</p> */}
                              {/* {data.description.length > TRUNCATE_LENGTH && (
                                <Button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenDialog(data);
                                  }}
                                  style={{ marginLeft: "10px", textTransform: "none" }}
                                >
                                  Read More
                                </Button>
                              )} */}
                            </div>

                            {/* <Card sx={{ maxWidth: 340, height: 150 }} className="mr-2 carddesign">
                      <CardActionArea className="mr-2 carddesign" onClick={() => handleOpenDialog(data)}>
                        <CardContent style={{ height: "150px" }}>
                          <Typography
                            className="d-flex justify-content-center text-decoration-underline"
                            gutterBottom
                            variant="h5"
                            component="div"
                          >
                            {data.title}
                          </Typography>
                          <Typography
                            className="heading-2-text"
                            style={{ marginLeft: "10px" }}
                          >
                            {data.description.length > TRUNCATE_LENGTH
                              ? `${data.description.substring(0, TRUNCATE_LENGTH)}...`
                              : data.description}
                          </Typography>
                          
                        </CardContent>
                      </CardActionArea>
                    </Card> */}
                          </div>
                        ))}

                        {/* <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                  <DialogTitle className="d-flex justify-content-center">
                    {selectedService?.title}
                  </DialogTitle>
                  <DialogContent>
                    <Typography>{selectedService?.description}</Typography>
                  </DialogContent>
                </Dialog> */}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}


          </Grid>
        </Box>
      ) : <NoServices />}
    </>
  );
}

export default CompanyServices;
